import I18n from 'I18n';
import always from 'transmute/always';
import { Map as ImmutableMap } from 'immutable';
import { toDSFilter, fromDSFilter } from './../../converters/reporting/Converters';
import { ExtensibleReports } from 'customer-data-filters-ui/filterQueryFormat/strategy/StrategyTypes';
import { getOperatorsForTypeWithOverrides } from './../../converters/reporting/ExtensibleReportsPropertyTypeToOperator';
import { deepFreeze } from '../../utils/utils';
import { StrategyBase } from '../StrategyBase';
import { getCRMSearchFieldDefinitionsForFilterFamily } from '../../converters/crmSearch/fieldDefinitions/CRMSearchFieldDefinitions';
import { BLOG_AUTHOR, BLOG_TAG, BLOGS, ANALYTICS_VIEW, SUBDOMAIN, SUBDOMAIN_ID
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
} from 'reference-resolvers/constants/ReferenceObjectTypes';
import { CATEGORY_KEYS } from '../../components/dataExplorer/categorySelection/Categories';
import { unwrapSingleCRMFilter, wrapSingleCRMFilter } from '../crmSearchStrategyUtils';
const getFilterFamilyGroupHeading = () => undefined;
const getFilterFamilyOptions = getFilterFamilyName => props => {
  const filterFamilyName = getFilterFamilyName(props.baseFilterFamily, props, false);
  const options = [{
    category: CATEGORY_KEYS.PROPERTIES,
    text: I18n.text('newCustomerDataFilters.FilterFamilyGroup.currentObject'),
    options: [{
      text: filterFamilyName,
      value: props.baseFilterFamily
    }]
  }];
  return options;
};
const serializer = {
  fromFormat: toDSFilter,
  toFormat: fromDSFilter
};
const getReferenceResolvers = resolvers => {
  return ImmutableMap({
    [ANALYTICS_VIEW]: resolvers.get(ANALYTICS_VIEW),
    [BLOG_AUTHOR]: resolvers.get(BLOG_AUTHOR),
    [BLOG_TAG]: resolvers.get(BLOG_TAG),
    [BLOGS]: resolvers.get(BLOGS),
    [SUBDOMAIN]: resolvers.get(SUBDOMAIN),
    [SUBDOMAIN_ID]: resolvers.get(SUBDOMAIN_ID)
  });
};

// Soon this should be replaced with SalesViewsStrategy, keeping for reverse compatibility
export class ExtensibleReportsFilterStrategy extends StrategyBase {}
export const ExtensibleReportsStrategyBuilder = ({
  getField,
  getFields,
  getFilterFamilyName,
  getFilterFamilyObjectName,
  reportingDataType
}) => {
  const strategy = new ExtensibleReportsFilterStrategy({
    getField,
    getFieldDefinitions: getCRMSearchFieldDefinitionsForFilterFamily,
    getFields,
    getFilterFamilyGroupHeading,
    getFilterFamilyName,
    getFilterFamilyObjectName,
    getFilterFamilyOptions: getFilterFamilyOptions(getFilterFamilyName),
    getIsFiscalYearEnabled: always(true),
    getOperatorsForType: getOperatorsForTypeWithOverrides(reportingDataType),
    getSpecialFieldOptions: () => ({}),
    serializer,
    wrapSingleFilter: wrapSingleCRMFilter,
    unwrapSingleFilter: unwrapSingleCRMFilter,
    strategyType: ExtensibleReports,
    getReferenceResolvers
  });
  return deepFreeze(strategy);
};